import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { Page, Spinner, Empty, severityMeta } from "@/components/shared";
import { Megaphone } from "lucide-react";

function timeAgo(iso) {
  const diff = (Date.now() - new Date(iso).getTime()) / 60000;
  if (diff < 1) return "just now";
  if (diff < 60) return `${Math.round(diff)} min ago`;
  return `${Math.round(diff / 60)} hr ago`;
}

export default function Updates() {
  const nav = useNavigate();
  const [ups, setUps] = useState(null);

  useEffect(() => {
    api.get("/band/updates").then(({ data }) => {
      setUps(data);
      localStorage.setItem("cs_cache_updates", JSON.stringify(data));
    }).catch(() => {
      const c = localStorage.getItem("cs_cache_updates");
      setUps(c ? JSON.parse(c) : []);
    });
  }, []);

  if (!ups) return <div className="px-6 pt-10"><Spinner /></div>;

  return (
    <Page className="px-5 pt-6">
      <button data-testid="updates-back" onClick={() => nav(-1)} className="cs-tap flex items-center gap-1 text-sm mb-4" style={{ color: "var(--cs-fg2)" }}>
        <ArrowLeft size={18} /> Back
      </button>
      <h1 className="font-head font-extrabold text-3xl">Band Updates</h1>
      <p className="mt-1 text-sm" style={{ color: "var(--cs-fg2)" }}>Live from your band leader</p>

      {ups.length === 0 ? (
        <Empty icon={Megaphone} title="No updates yet" sub="Your band's messages will appear here." />
      ) : (
        <div className="mt-5 space-y-3">
          {ups.map((u) => {
            const m = severityMeta(u.severity);
            return (
              <div key={u.id} data-testid={`update-${u.id}`} className="cs-card p-4" style={{ borderLeft: `4px solid ${m.color}` }}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-[10px] font-bold tracking-wide uppercase" style={{ color: m.color }}>{m.label}</span>
                  <span className="text-xs" style={{ color: "var(--cs-fg2)" }}>{timeAgo(u.created_at)}</span>
                </div>
                <p className="font-head font-bold text-lg leading-tight">{u.title}</p>
                <p className="text-sm mt-1" style={{ color: "var(--cs-fg2)" }}>{u.body}</p>
              </div>
            );
          })}
        </div>
      )}
    </Page>
  );
}
